import {UrlObj} from "./other/UrlObj";
import {ServerService} from "../services/server.service";
import {Injectable} from "@angular/core";
import {DataService} from "../services/data.service";

@Injectable({
   providedIn: 'root'
})
export class TessutoProdottoFactory {

   constructor(private serverSrv: ServerService,
               private dataSrv: DataService) {
   }

   async getTessutiProdotto(prodottoId, vendorSlug):Promise<TessutoProdotto[]> {

      return new Promise((resolve, reject) => {
         let url = vendorSlug ? `/api/esercizi/${vendorSlug}/prodotti/${prodottoId}/tessutiprodotti` : `/api/prodotti/${prodottoId}/tessutiprodotti`
         ServerService.instance.getAll(TessutoProdotto, url).then(res=>{
            resolve(res)
         }).catch(err=>{
            reject(err)
         })
      })
   }

   async postTessutoProdotto(prodottoId, data, vendorSlug=null):Promise<TessutoProdotto[]> {
      let url = vendorSlug ? `/api/esercizi/${vendorSlug}/prodotti/${prodottoId}/tessutiprodotti` : `/api/prodotti/${prodottoId}/tessutiprodotti`
      return new Promise((resolve, reject) => {
         ServerService.instance.post( url, data, TessutoProdotto).then(res=>{
            resolve(res)
         }).catch(err=>{
            reject(err)
         })
      })
   }

   async putTessutoProdotto(prodottoId, tessutoProdId, data):Promise<TessutoProdotto[]> {
      return new Promise((resolve, reject) => {
         ServerService.instance.put( `/api/prodotti/${prodottoId}/tessutiprodotti/${tessutoProdId}`, data, TessutoProdotto).then(res=>{
            resolve(res)
         }).catch(err=>{
            reject(err)
         })
      })
   }

   async deleteTessutoProdotto(prodottoId, tessutoProdId, vendorSlug=null):Promise<TessutoProdotto[]> {
      let url = vendorSlug ? `/api/esercizi/${vendorSlug}/prodotti/${prodottoId}/tessutiprodotti/${tessutoProdId}` : `/api/prodotti/${prodottoId}/tessutiprodotti/${tessutoProdId}`
      return new Promise((resolve, reject) => {
         ServerService.instance.delete( url, {}, TessutoProdotto).then(res=>{
            resolve(res)
         }).catch(err=>{
            reject(err)
         })
      })
   }

}

export class TessutoProdottoData {
  id?: number;
  percentuale?: number;
  tessuto?: number;
  prodotto?: number;
}

export class TessutoProdotto {

  data:TessutoProdottoData = {}

  constructor(data:TessutoProdottoData) {
    // assegno al mio oggetto data (è un json)
    if(!data) data = {}
    Object.assign(this.data, data)
  }

   public static BASE_URL(path=null, queryParams={}):string{
      let url:UrlObj = new UrlObj(`/api/tessutiprodotti`, queryParams);
      if(path) url.url += path;
      return url.toString()
   }

}
